import {OmapiCharacteristics} from './omapi-characteristics';
import {PriceDetail} from './ocapi/price-detail';
import {StreamingOption} from './sofy/sales-offer/option';

export class TvShopEntertainmentPack {
  omapiId: string;
  priceDetail: PriceDetail;
  omapiCharacteristics?: OmapiCharacteristics;
  isHidden?: boolean;
  subscribed?: boolean;
  hasDayPass?: boolean;
  hasTrial?: boolean;
  isUpgrade?: boolean;
  isDayPass?: boolean;
  isDowngrade?: boolean;
  isTrial?: boolean;
  endDate?: Date;
  collectionBlock?: boolean;
  futureProduct?: string;
  isStreamingBundle?: boolean;
  isStreamzGroup?: boolean;
  isStreamingStandaloneProduct?: boolean;
  downgradeUpgradeOmapiIds?: Array<string>;
  streamingOption?: StreamingOption[];
  isGroupPack?: boolean;
  childPacks?: TvShopEntertainmentPack[];
  defaultChildPack?: TvShopEntertainmentPack;
  showSubtitleInCarousel?: boolean;
  isSoho?: boolean;

  public static createTvShopEntertainmentPack(packVariablesWithoutMethods: TvShopEntertainmentPack): TvShopEntertainmentPack {
    const result = new TvShopEntertainmentPack();
    result.omapiId = packVariablesWithoutMethods.omapiId;
    result.priceDetail = packVariablesWithoutMethods.priceDetail;
    result.isHidden = packVariablesWithoutMethods.isHidden;
    result.subscribed = packVariablesWithoutMethods.subscribed;
    result.isUpgrade = packVariablesWithoutMethods.isUpgrade;
    result.isDowngrade = packVariablesWithoutMethods.isDowngrade;
    result.isTrial = packVariablesWithoutMethods.isTrial;
    result.hasTrial = packVariablesWithoutMethods.hasTrial;
    result.isDayPass = packVariablesWithoutMethods.isDayPass;
    result.omapiCharacteristics = packVariablesWithoutMethods.omapiCharacteristics;
    result.hasDayPass = packVariablesWithoutMethods.hasDayPass;
    result.endDate = packVariablesWithoutMethods.endDate;
    result.collectionBlock = packVariablesWithoutMethods.collectionBlock;
    result.downgradeUpgradeOmapiIds = packVariablesWithoutMethods.downgradeUpgradeOmapiIds;
    return result;
  }

  public isOrderable(): boolean {
    return !this.subscribed && (!this.isDowngrade || this.isDayPass || this.isTrial);
  }
}
